module.exports = __webpack_public_path__ + "static/media/birch-bw.3ce22b77.jpg";